/*
 * @Author: Erlin
 * @CreateTime: 2020-08-28 17:37:48
 * @LastEditors: Erlin
 * @LastEditTime: 2020-09-06 11:15:06
 * @Description: 我的
 */
import { BindAll } from 'lodash-decorators'
import { EnumApiMy } from '../../api'
import { AjaxBasics } from '../../helpers/ajaxBasics'
import MySunWork from './mySunWork'
import MyWork from './myWork'
import BishanWork from './bishanWork'
import { ControllerBiShan } from './myBiShan'
import MyCoin from './myCoin'
import { EnumProductTypeQuery } from '@xt/client/enums'
import { CourseItem, MyCourseList } from '@xt/client/types/my-go-course'
import { $service } from '@xt/client/experimental/request/service'

@BindAll()
export class ControllerMy {
  constructor(protected $ajax: AjaxBasics) {}
  /**
   * 晒作业
   * @memberof ControllerMy
   */
  MyWork = new MyWork(this.$ajax)

  /**
   * 我晒出的作业
   * @memberof ControllerMy
   */
  MySunWork = new MySunWork(this.$ajax)

  /**
   * 笔山相关
   */
  BishanWork = new BishanWork(this.$ajax)

  /**
   * 我的积分页面，笔山明细 @mengxd
   * **/
  MyBishan = new ControllerBiShan()

  MyCoin = new MyCoin()

  /**
   * 获取我的课程列表
   */
  async onGetMyProductList() {
    // 后台直接返的课程不是按照报名时间排序的
    const [err, res] = await $service<MyCourseList>({
      url: EnumApiMy.MyCourseList
    })

    if (err) throw err

    const progressingCourse: CourseItem[] = []

    if (res.courseResultVOS) {
      res.courseResultVOS.forEach(item => {
        progressingCourse.push({ ...item, type: EnumProductTypeQuery.Course })
      })
    }
    if (res.activityResultVOS) {
      res.activityResultVOS.forEach(item => {
        progressingCourse.push({ ...item, type: EnumProductTypeQuery.DayCourse })
      })
    }
    if (res.showResultVOS) {
      res.showResultVOS.forEach(item => {
        progressingCourse.push({ ...item, type: EnumProductTypeQuery.Exhibition })
      })
    }
    if (res.selfStudyResultVOS) {
      res.selfStudyResultVOS.forEach(item => {
        progressingCourse.push({ ...item, type: EnumProductTypeQuery.SelfStudy })
      })
    }
    if (res.specialCourseResults) {
      res.specialCourseResults.forEach(item => {
        progressingCourse.push({ ...item, type: EnumProductTypeQuery.SpecialCourse })
      })
    }
    if (res.remedialShowResults) {
      res.remedialShowResults.forEach(item => {
        progressingCourse.push({ ...item, type: EnumProductTypeQuery.Exhibition })
      })
    }

    // 按报名时间排序
    return this.handleSortBySuccessTime({ ...res, progressingResultVOS: progressingCourse })
  }

  // 统一根据购买时间倒序排序
  handleSortBySuccessTime(courseList: MyCourseList & { progressingResultVOS: CourseItem[] }) {
    Object.keys(courseList).forEach(key => {
      if (!courseList[key]) return
      courseList[key].sort((a, b) => b.successTime - a.successTime)
    })
    return courseList
  }

  /**
   * 获取我的全部课程列表
   * @returns
   */
  async onGetMyAllProduct() {
    const res: Array<CourseItem> = await this.$ajax.get(EnumApiMy.MyAllCourse)
    return res.sort((a, b) => b.successTime - a.successTime)
  }
}
export default ControllerMy
